import React from 'react';
import { BannerProps, money } from './BannerProps';

/**
 * Design 6: thin strip. One line in the brand color, adds almost no
 * height to the receipt. Owner-approved mockup #06.
 */
const StripBanner: React.FC<BannerProps> = ({ promotion, brandColor = '#1e5aa8' }) => {
  const primary = promotion.rows[0] ?? null;
  const was = primary ? primary.wasCents : promotion.wasTotalCents;
  const now = primary ? primary.priceCents : promotion.totalCents ?? 0;
  const through = promotion.finePrint ?? (promotion.endsAt ? `book by ${promotion.endsAt}` : null);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        flexWrap: 'wrap',
        background: brandColor,
        color: '#fff',
        borderRadius: 6,
        padding: '10px 14px',
        fontFamily: 'Helvetica, Arial, sans-serif',
      }}
    >
      <span style={{ fontSize: 13, fontWeight: 700 }}>{promotion.headline ?? promotion.name}</span>
      <span style={{ fontSize: 13, display: 'flex', gap: 8, alignItems: 'baseline' }}>
        {was !== null && (
          <span style={{ textDecoration: 'line-through', opacity: 0.75 }}>{money(was)}</span>
        )}
        <b>{money(now)}</b>
      </span>
      {through && <span style={{ fontSize: 11, opacity: 0.9 }}>{through}</span>}
    </div>
  );
};

export default StripBanner;
